import { render, staticRenderFns } from "./MonthlyDocuments.vue?vue&type=template&id=6dd3f08e&scoped=true"
import script from "./MonthlyDocuments.vue?vue&type=script&scoped=true&lang=js"
export * from "./MonthlyDocuments.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./MonthlyDocuments.vue?vue&type=style&index=0&id=6dd3f08e&prod&scoped=true&lang=css"
import style1 from "./MonthlyDocuments.vue?vue&type=style&index=1&id=6dd3f08e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd3f08e",
  null
  
)

export default component.exports